import { FullPageContent } from '@/components/layout/full-page-content';

import { DataExplorerResult } from '../components/data-explorer-result';
import { FilterBar } from '../components/filters/data-explorer-filters';
import { useFilters } from '../hooks/use-filters';

export function DataExplorerPageV2() {
  const { filters, domain, updateFilters, updateDomain } = useFilters();

  return (
    <FullPageContent scrollable testId="data-explorer-page">
      <FilterBar
        filters={filters}
        domain={domain}
        onChange={updateFilters}
        onDomainChange={updateDomain}
      />
      <DataExplorerResult
        filters={filters}
        domain={domain}
        onUpdateFilters={updateFilters}
      />
    </FullPageContent>
  );
}
